import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, ItemisationAdjustment } from '../../Components/Form';
import { useCustomer } from '../../Data/Customers';

const EditItemisationAdjustment = ({job, onClose, then}) => {
    return <Modal title="Invoice Adjustment" isOpen={!!job} setIsOpen={onClose} dismissible>

        <p className="prose text-sm text-muted my-2">
            Adjust the cost of the next invoice for this job.<br />
            After the next invoice, the cost will revert to the original amount.
        </p>

        {job && <Inner {...{job, then}} />}
    </Modal>
}

const Inner = ({job, then}) => {
    const {updateJobItemisationAdjustment} = useCustomer(job.customerId);
    const data = {
        itemisationAdjustment: job.itemisationAdjustment,
    }

    return <Form onSubmit={(data) => updateJobItemisationAdjustment(job.id, data)} data={data} afterSubmit={then} closeModalOnSubmit>
        <ItemisationAdjustment originalCost={job.cost}
            help={v => v === false && data.itemisationAdjustment ? 'The invoice adjustment will be removed' : null}
        />
        <Actions submit={{label: 'Save'}} cancel />
    </Form>;
}

export default EditItemisationAdjustment;
